export const copyText = async (text: string) => {
  try {
    await navigator.clipboard.writeText(text);
  } catch {
    // Silently fail if clipboard access is denied
  }
};
